import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@environment';
import { OrganizationViewModel } from '@features/models/organization.model';
import { ResellerViewModel } from '@features/models/reseller.model';
import { Result } from '@shared/models/result.model';

@Injectable({ providedIn: 'root' })
export class PublicService {
  private url = `${environment.apis.linkroom}/public`;

  constructor(private http: HttpClient) {}

  getByHostname() {
    const headers = new HttpHeaders().set('Bypass-Interceptor', 'true');
    return this.http.get<Result<ResellerViewModel>>(`${this.url}/resellers`, { headers });
  }

  checkRoomExists(id: string) {
   const headers = new HttpHeaders().set('Bypass-Interceptor', 'true');
   return this.http.get<Result<ResellerViewModel>>(`${this.url}/room/${id}`, { headers });
 }

 getRoomWelcomeData(id: string) {
   const headers = new HttpHeaders().set('Bypass-Interceptor', 'true');
   return this.http.get<Result<OrganizationViewModel>>(`${this.url}/room/welcome-data/${id}`, { headers });
 }
}
